import React from 'react'
import { PHeadline } from "@porsche-design-system/components-react";

function MissingPage() {
    return (
        <PHeadline variant="headline-2" align="center">Page Not Found</PHeadline>
    )
}

export default MissingPage;